import * as React from 'react';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import {Button, Stack, Typography} from "@mui/material";
import {useEffect, useState} from "react";
import { CategoryCard } from '../components/CategoryCard';
import {useNavigate} from "react-router-dom";
import Skeleton from "@mui/material/Skeleton";
import {Icon} from "@iconify/react";
import {AddNewDevice} from "../components/ModelComponents/AddNewDevice";
import {Model} from "../components/Model";

// @ts-ignore
import glucoseLogo from '../assets/img/glucose.png'
import services from "../services";
import {useSelector,useDispatch} from "react-redux";
import {RootState} from "../app/store";
import {setInitialCategories, setInitialDevices,setInitialDistinctDevices} from "../app/features/userSlice";

interface Readings {
    "mm/hg" ?  : string,
    "mg/dl"  ? : string,
    "bpm" ? : string,
    "SPO2" ?  : string,
}


export interface Categories{
    id : number,
    logo : string,
    name : string,
    readings  : Readings
}


const skeltonCards = [1,2,3,4,5,6,7,8,9,10,11,12]

const readings = [1,2,3]

const StackRowSekelton = () =>{
    return(
        <Stack alignItems="center">
            <Typography
                fontSize={18}
                color="#089BAB"
                fontWeight={400}
                letterSpacing={1}
            >
                <Skeleton variant="text" width={20} animation="wave" />
            </Typography>
            <Typography
                fontSize={15}
                fontWeight={500}
                color="#121A2D"
            >
                <Skeleton variant="text" width={20} animation="wave" />
            </Typography>
        </Stack>
    )
}



export const Dashboard = () =>{

    const dispatch = useDispatch()

    const allCategories = useSelector(((state:RootState) => state.user.categories))

    const [skelton,setSkelton] = useState<boolean>(true)

    const [showAddDeviceModel,setShowAddDeviceModel] = useState<boolean>(false)

    const handleClose = () => {
        setShowAddDeviceModel(false)
        getLatestValues()
    }
    const modelComponent = ()=>{
        return (
            <AddNewDevice handleClose={handleClose} />
        )
    }

    const getLatestValues = () =>{
            setSkelton(true)
            services.GetLatestReadings()
                .then(response=>{
                    localStorage.setItem('categories',JSON.stringify(response.data.categories))
                    localStorage.setItem('devices',JSON.stringify(response.data.devices))
                    localStorage.setItem('distinctDevices',JSON.stringify(response.data.distinctDevices))
                    dispatch(setInitialCategories(response.data.categories))
                    dispatch(setInitialDevices(response.data.devices))
                    dispatch(setInitialDistinctDevices(response.data.distinctDevices))
                    setSkelton(false)
                })
                .catch(error=>{
                    console.log(error)
                })
    }

    useEffect(()=>{
        getLatestValues()
    },[])


    return (
            <Box sx={{flexGrow:1}}>
                <Model
                    open={showAddDeviceModel}
                    handleClose={handleClose}
                    Component = {modelComponent}
                />
                <Grid
                    container
                    direction="row"
                    justifyContent="space-between"
                    alignItems="center"
                    paddingBottom={5}
                >
                    <Grid item>
                        <Typography
                            fontSize={32}
                            fontWeight={700}
                            color="#081735"
                        >
                            Dashboard
                        </Typography>
                    </Grid>
                    <Grid item>
                        {
                            localStorage.getItem('user_role') === 'user'
                            ?
                                <Button
                                    onClick={()=>setShowAddDeviceModel(true)}
                                    variant="contained"
                                    sx={{
                                        borderRadius:"16px",
                                        background:"#089BAB",
                                        textTransform:"none",
                                        color:"#F9FAFC",
                                        fontWeight:700,
                                        padding:2,
                                        boxShadow:"none",
                                        fontSize : "16px",
                                        "&:hover": {
                                            //you want this to be the same as the backgroundColor above
                                            backgroundColor: "#089BAB"
                                        }
                                    }}> <Icon icon="carbon:add-filled" /> &nbsp; Add a new Device</Button>
                                :''
                        }
                    </Grid>
                </Grid>
                <Grid container>
                    <Grid item>
                        <Typography
                            fontSize={24}
                            fontWeight={500}
                            color="#081735"
                        >
                            Categories

                        </Typography>
                    </Grid>
                </Grid>
                <Grid container spacing={6} marginTop={1}>
                    {
                        !skelton ?
                            allCategories.map((d,index)=>(
                                <CategoryCard
                                    key={index}
                                    id={d.id}
                                    name = {d.name}
                                    image  = {d.logo}
                                    readings={d.readings}
                                />
                            ))
                            :
                            skeltonCards.map((e)=>(
                                <Grid item md={6} sm={10} xs={12} lg={4} xl={3} key={e}>
                                    <Stack spacing={2} alignItems="center" className="card-skeleton">
                                        <div className="dashboard--portrait-skeleton">
                                            <Skeleton variant="circular" animation="wave" width={105} height={105} />
                                        </div>
                                        <Skeleton variant="text" width={150} animation="wave" />
                                        <Stack direction="row" spacing={2}>
                                            {
                                                readings.map(e=>(
                                                    <StackRowSekelton  key={e} />
                                                ))
                                            }
                                        </Stack>
                                    </Stack>
                                </Grid>
                            ))
                    }

                </Grid>
            </Box>
    )
}